import {useEffect, useState} from 'react'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useUserSelector} from '../../../../../app/store/user'
import {GetMyMenuService} from '../../../../../app/service/menu.service'

const SidebarMenuMain = () => {
  const {user, myCompany} = useUserSelector()
  const [menu, setMenu] = useState<any>()

  useEffect(() => {
    if (menu) return
    if (user) {
      getMenus()
    }
  }, [user])

  const getMenus = async () => {
    let params = {}
    if (myCompany) {
      params = {
        companyId: myCompany.company.id,
      }
    }
    const getMenuService = new GetMyMenuService()
    const _menu = await getMenuService.request(params)
    setMenu(_menu)
  }

  return (
    <>
      {menu &&
        menu.map((main, i) => {
          return (
            <div key={i}>
              {main.title !== 'Manual' && (
                <>
                  {main.subMenu.length > 0 && (
                    <SidebarMenuItemWithSub to={main.link} title={main.title} icon={main.icon}>
                      {main.subMenu.map((subMenu, j) => {
                        return (
                          <SidebarMenuItem
                            key={j}
                            to={subMenu.link}
                            title={subMenu.title}
                            hasBullet={true}
                          />
                        )
                      })}
                    </SidebarMenuItemWithSub>
                  )}
                  {main.subMenu.length === 0 && (
                    <>
                      <SidebarMenuItem to={main.link} title={main.title} icon={main.icon} />
                    </>
                  )}
                </>
              )}
            </div>
          )
        })}
    </>
  )
}

export {SidebarMenuMain}
